<template>
  <div id="data-report-config-form" :style="{ height: pageHeight + 'px' }">
    <Viewport v-model="pageHeight">
      <el-form
        class="config-form ghost-button-styles"
        v-loading="getConfigLoading"
        ref="config-form"
        :rules="rules"
        :validate-on-rule-change="false"
        :model="configForm"
        label-width="80px"
      >
        <el-form-item label="上报任务" prop="ruleName">
          <el-input v-model="configForm.ruleName" placeholder=""></el-input>
        </el-form-item>

        <el-form-item label="类型">
          <el-radio-group v-model="configForm.controlType">
            <el-radio-button v-for="item in DataReports.DATA_TYPE_LIST" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="游戏选择">
          <el-radio-group v-model="configForm.gameType">
            <el-radio-button v-for="item in DataReports.GAME_TYPE_LIST" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item prop="game">
          <div class="selector">
            <div class="lists">
              <el-input class="search-box" v-model="gameSearchString" clearable></el-input>
              <div class="checkbox-wrapper">
                <el-checkbox-group v-if="configForm.gameType === DataReports.GAME_TYPES.MIDDLEWARE" v-model="configForm.mgameIds">
                  <div class="checkbox-item" v-for="item in gameData.middleware" :key="item.id">
                    <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                  </div>
                </el-checkbox-group>

                <el-checkbox-group v-else-if="configForm.gameType === DataReports.GAME_TYPES.GROUP" v-model="configForm.gameGroupIds">
                  <div class="checkbox-item" v-for="item in gameData.group" :key="item.groupId">
                    <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                  </div>
                </el-checkbox-group>

                <el-checkbox-group v-else v-model="configForm.gameIds">
                  <div class="checkbox-item" v-for="item in gameData.game" :key="item.id">
                    <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>

            <ResultBlock
              v-model="gameResultTab"
              :results="gameResults"
              :radios="gameRadios"
              @remove-all="onRemoveAllResult('game')"
              @remove-item="onRemoveGameItem"
            ></ResultBlock>
          </div>
        </el-form-item>

        <el-form-item label="媒体">
          <el-radio-group v-model="configForm.mediaType">
            <el-radio-button
              v-for="item in [
                { label: '不限', value: 1 },
                { label: '选择媒体', value: 2 }
              ]"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-show="configForm.mediaType === 2">
          <div class="selector">
            <div class="lists">
              <el-input class="search-box" v-model="mediaSearchString" clearable></el-input>
              <div class="checkbox-wrapper">
                <el-checkbox-group v-model="configForm.mediaIds">
                  <div class="checkbox-item" v-for="item in mediaData" :key="item.id">
                    <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>

            <ResultBlock
              v-model="mediaResultTab"
              :results="mediaResults"
              :radios="mediaRadios"
              @remove-all="onRemoveAllResult('media')"
              @remove-item="onRemoveMediaItem"
            ></ResultBlock>
          </div>
        </el-form-item>

        <el-form-item label="账号">
          <el-radio-group v-model="configForm.accountType">
            <el-radio-button
              v-for="item in [
                { label: '不限', value: 1 },
                { label: '选择账号', value: 2 }
              ]"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-show="configForm.accountType === 2">
          <div class="selector">
            <div class="lists">
              <el-input class="search-box" v-model="accountSearchString" clearable></el-input>
              <div class="checkbox-wrapper">
                <el-checkbox-group v-model="configForm.accountIds">
                  <div class="checkbox-item" v-for="item in accountData" :key="item.id">
                    <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>

            <ResultBlock
              v-model="accountResultTab"
              :results="accountResults"
              :radios="accountRadios"
              @remove-all="onRemoveAllResult('account')"
              @remove-item="onRemoveAccountItem"
            ></ResultBlock>
          </div>
        </el-form-item>

        <el-form-item prop="exceptionRule" label="规则" v-if="configForm.controlType === DataReports.DATA_TYPES.EXCEPTION">
          <div class="rule-row">
            <span>在用户等级&le;&ensp;</span>
            <el-input style="width: 130px" v-model="configForm.exceptionConfig.role_level" placeholder="1~9999之间整数"></el-input>&ensp;
            <span>首笔充值金额&le;&ensp;</span>
            <el-input style="width: 130px" v-model="configForm.exceptionConfig.first_order_money" placeholder="1~9999之间整数"></el-input
            >&ensp;
            <span>不进行上报媒体付费</span>
          </div>
        </el-form-item>

        <template v-if="configForm.controlType === DataReports.DATA_TYPES.REPORT">
          <el-form-item label="规则" prop="reportingActiveRule">
            <div class="rule-row">
              <el-checkbox
                v-model="configForm.reportConfig.active_call_check"
                :disabled="configForm.reportConfig.active_call_check"
                @change="onCheckStateChange($event, 'active_call', 'active')"
              >
                激活行为上报
              </el-checkbox>
              <el-radio
                v-model="configForm.reportConfig.active_call.event"
                :disabled="!configForm.reportConfig.active_call_check"
                label="active"
                @change="onActiveRadioChange"
              >
                用户激活时
              </el-radio>
              <el-radio
                v-model="configForm.reportConfig.active_call.event"
                :disabled="!configForm.reportConfig.active_call_check"
                label="role"
                @change="onActiveRadioChange"
                >用户创角时</el-radio
              >
            </div>
          </el-form-item>

          <el-form-item prop="reportingRegRule">
            <div class="rule-row">
              <el-checkbox v-model="configForm.reportConfig.regist_call_check" @change="onCheckStateChange($event, 'regist_call', 'regist')"
                >注册行为上报
              </el-checkbox>
              <el-radio
                v-model="configForm.reportConfig.regist_call.event"
                label="regist"
                :disabled="configForm.reportConfig.active_call.event === 'role' || !configForm.reportConfig.regist_call_check"
                >用户注册时
              </el-radio>
              <el-radio
                v-model="configForm.reportConfig.regist_call.event"
                label="role"
                :disabled="!configForm.reportConfig.regist_call_check"
                >用户创角时
              </el-radio>
            </div>
          </el-form-item>
          <el-form-item prop="reportingPayRule">
            <div class="rule-row">
              <el-checkbox v-model="configForm.reportConfig.pay_call_check" @change="onCheckStateChange($event, 'pay_call', 'pay')">
                付费行为上报
              </el-checkbox>

              <el-radio v-model="configForm.reportConfig.pay_call.event" :disabled="!configForm.reportConfig.pay_call_check" label="pay">
                每次付费时
              </el-radio>
            </div>
          </el-form-item>
          <ConditionSet
            :settings.sync="configForm.reportConfig.pay_call.settings"
            :report-type="configForm.reportConfig.pay_call.report_condition"
            @change-report-type="configForm.reportConfig.pay_call.report_condition = $event"
            v-if="configForm.reportConfig.pay_call_check"
          />
          <el-form-item prop="reportingEventRule">
            <div class="rule-row">
              <el-checkbox
                v-model="configForm.reportConfig.event_call_check"
                @change="onCheckStateChange($event, 'event_call', 'first_pay')"
              >
                关键行为上报
              </el-checkbox>
              <el-radio
                v-model="configForm.reportConfig.event_call.event"
                :disabled="!configForm.reportConfig.event_call_check"
                label="first_pay"
                >首次付费时</el-radio
              >
              <el-radio
                v-model="configForm.reportConfig.event_call.event"
                :disabled="!configForm.reportConfig.event_call_check"
                label="create_role_in_2h"
              >
                <span>创角2小时内升到等级&ensp;</span>
                <el-input
                  v-model="configForm.reportConfig.event_call.ext.role_level"
                  :disabled="!configForm.reportConfig.event_call_check"
                  style="width: 90px"
                  placeholder="1~9999级"
                ></el-input>
                <span>&ensp;时上报</span>
              </el-radio>
            </div>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button type="primary" @click="onConfigSubmit" :loading="submitLoading">确认</el-button>
          <el-button @click="gotoListPage">取消</el-button>
        </el-form-item>
      </el-form>
    </Viewport>
  </div>
</template>
<script>
import ConditionSet from './components/condition-set.vue'
import ResultBlock from './components/transfer-selector.vue'
import DataReports from './data/data-reports.class.js'
import { getDataReportingInfoByPage, submitReortingConfig } from '@/api/report.model'
import { initPageData, MEDIA_ACCOUNTS, GAME_GROUPS, POPULAR_GAMES, MEDIAS, MID_GAMES } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([MEDIA_ACCOUNTS, GAME_GROUPS, MID_GAMES, POPULAR_GAMES, MEDIAS])

export default {
  components: {
    ResultBlock,
    ConditionSet
  },
  data() {
    return {
      pageHeight: 500,
      getConfigLoading: false,
      submitLoading: false,
      gameSearchString: '', // 过滤筛选游戏
      mediaSearchString: '', // 过滤筛选媒体
      accountSearchString: '', // 过滤筛选账号
      configForm: DataReports.getConfigForm(),
      rules: DataReports.makeConfigFormValidRules.call(this),
      gameResultTab: DataReports.GAME_TYPES.MIDDLEWARE, // 默认中间件
      mediaResultTab: DataReports.MEDIA_TYPES.MEDIA, // 默认媒体
      accountResultTab: DataReports.ACCOUNT_TYPES.ACCOUNT // 默认账号
    }
  },

  computed: {
    ...PAGE_REQUIRED_OPTS,

    // 数据上报类型
    DataReports() {
      return DataReports
    },
    /**
     * @description: 根据筛选条件获取游戏数据
     */
    gameData() {
      const str = this.gameSearchString
      return {
        middleware: this.MID_GAMES.filter((m) => m.name.includes(str)),
        group: this.GAME_GROUPS.filter((m) => m.name.includes(str)),
        game: this.POPULAR_GAMES.filter((m) => m.name.includes(str))
      }
    },
    /**
     * @description: 根据筛选条件获取媒体数据
     */
    mediaData() {
      const str = this.mediaSearchString
      return this.MEDIAS.filter((m) => m.name.includes(str))
    },
    /**
     * @description: 根据筛选条件获取媒体数据
     */
    accountData() {
      const str = this.accountSearchString
      return this.MEDIA_ACCOUNTS.filter((m) => m.name.includes(str))
    },

    /**
     * @description: 游戏已选结果，根据已选id获取json
     */
    gameResults() {
      const { mgameIds, gameGroupIds, gameIds } = this.configForm
      switch (this.gameResultTab) {
        case DataReports.GAME_TYPES.MIDDLEWARE:
          return this.MID_GAMES.filter((m) => mgameIds.includes(m.id))
        case DataReports.GAME_TYPES.GROUP:
          return this.GAME_GROUPS.filter((m) => gameGroupIds.includes(m.id))
        case DataReports.GAME_TYPES.GAME:
          return this.POPULAR_GAMES.filter((m) => gameIds.includes(m.id))
        default:
          return []
      }
    },
    /**
     * @description: 媒体已选结果，根据已选id获取json
     */
    mediaResults() {
      const { mediaIds } = this.configForm
      return this.MEDIAS.filter((m) => mediaIds.includes(m.id))
    },
    /**
     * @description: 账号已选结果，根据已选id获取json
     */
    accountResults() {
      const { accountIds } = this.configForm
      return this.MEDIA_ACCOUNTS.filter((m) => accountIds.includes(m.id))
    },

    /**
     * @description: 游戏类型的radio选项，并且注入每个游戏类型的已选个数
     */
    gameRadios() {
      return DataReports.GAME_TYPE_LIST.map((m) => ({
        ...m,
        sum: this.configForm[m.key].length
      }))
    },
    /**
     * @description: 媒体类型的radio选项，并且注入每个媒体类型的已选个数
     */
    mediaRadios() {
      return DataReports.MEDIA_TYPE_LIST.map((m) => ({
        ...m,
        sum: this.configForm[m.key].length
      }))
    },
    /**
     * @description: 账号类型的radio选项，并且注入每个账号类型的已选个数
     */
    accountRadios() {
      return DataReports.ACCOUNT_TYPE_LIST.map((m) => ({
        ...m,
        sum: this.configForm[m.key].length
      }))
    }
  },
  methods: {
    /**
     * @description: 提交配置信息
     * @return {*}
     */
    onConfigSubmit() {
      this.$refs['config-form'].validate((valid) => {
        if (valid) {
          let { exceptionConfig, reportConfig, accountType, mediaType, gameType, ...params } = this.configForm

          if (params.controlType === DataReports.DATA_TYPES.EXCEPTION) {
            params = {
              ...params,
              ruleConfig: JSON.stringify(exceptionConfig)
            }
          }
          if (params.controlType === DataReports.DATA_TYPES.REPORT) {
            const { active_call_check, regist_call_check, pay_call_check, event_call_check, ...restConfig } = reportConfig
            const ruleConfig = {}
            if (active_call_check) {
              ruleConfig.active_call = restConfig.active_call
            }
            if (regist_call_check) {
              ruleConfig.regist_call = restConfig.regist_call
            }

            if (pay_call_check) {
              const { event, settings, report_condition } = restConfig.pay_call

              // 去掉pay_call里面，保存等级和金额的ext参数
              ruleConfig.pay_call = {
                event,
                // 添加顺序参数
                settings: settings.map((row, index) => {
                  return {
                    ...row,
                    order: index + 1
                  }
                }),
                report_condition
              }
            }

            if (event_call_check) {
              const { event } = restConfig.event_call
              if (event === 'create_role_in_2h') {
                ruleConfig.event_call = restConfig.event_call
              } else {
                // 去掉pay_call里面，保存等级的ext参数
                ruleConfig.event_call = {
                  event
                }
              }
            }

            params = {
              ...params,
              ruleConfig: JSON.stringify(ruleConfig)
            }
          }

          const { mgameIds, gameGroupIds, gameIds, accountIds, mediaIds, ...newParams } = params

          if (gameIds?.length) {
            newParams.gameIds = gameIds.join(',')
          }

          if (mgameIds?.length) {
            newParams.mgameIds = mgameIds.join(',')
          }

          if (gameGroupIds?.length) {
            newParams.gameGroupIds = gameGroupIds.join(',')
          }

          if (accountIds?.length && accountType === DataReports.ACCOUNT_TYPES.ACCOUNT) {
            newParams.accountIds = accountIds.join(',')
          }

          if (mediaIds?.length && mediaType === DataReports.MEDIA_TYPES.MEDIA) {
            newParams.mediaIds = mediaIds.join(',')
          }

          this.submitLoading = true
          submitReortingConfig(newParams)
            .then((data) => {
              if (data) {
                this.gotoListPage()
              }
              this.submitLoading = false
            })
            .catch(() => {
              this.submitLoading = false
            })
        }
      })
    },
    onActiveRadioChange(radio) {
      // 当激活行为选中用户创角时，注册行为也需要选择用户创角
      if (radio === 'role' && this.configForm.reportConfig.regist_call_check) {
        this.configForm.reportConfig.regist_call.event = 'role'
      }
    },
    gotoListPage() {
      this.$router.replace({ name: 'datareportcontrol' })
    },
    /**
     * @description: 清除单条选中游戏
     */
    onRemoveGameItem(item) {
      const { key } = DataReports.GAME_TYPE_LIST.find((m) => m.value === this.gameResultTab) || {}
      this.onRemoveItem(key, item)
    },
    /**
     * @description: 清除单条选中媒体
     */
    onRemoveMediaItem(item) {
      const { key } = DataReports.MEDIA_TYPE_LIST.find((m) => m.value === this.mediaResultTab) || {}
      this.onRemoveItem(key, item)
    },
    /**
     * @description: 清除单条选中账号
     */
    onRemoveAccountItem(item) {
      const { key } = DataReports.ACCOUNT_TYPE_LIST.find((m) => m.value === this.accountResultTab) || {}
      this.onRemoveItem(key, item)
    },
    onRemoveItem(key, item) {
      if (key) {
        this.configForm[key] = this.configForm[key].filter((id) => id !== item.id)
      }
    },
    onCheckStateChange(flag, prop, defaultEvent) {
      // 取消勾选时，清除选择的事件
      if (!flag) {
        this.configForm.reportConfig[prop].event = ''
      } else {
        this.configForm.reportConfig[prop].event = defaultEvent
        this.onActiveRadioChange(this.configForm.reportConfig.active_call.event)
      }
      this.$nextTick(() => {
        this.$refs['config-form'].clearValidate()
      })
    },
    /**
     * @description: 清空全部已选游戏
     * @return {*}
     */
    onRemoveAllResult(type) {
      switch (type) {
        case 'game':
          this.configForm.mgameIds = []
          this.configForm.gameGroupIds = []
          this.configForm.gameIds = []
          break
        case 'media':
          this.configForm.mediaIds = []
          break
        case 'account':
          this.configForm.accountIds = []
          break
        default:
          break
      }
    },
    /**
     * @description: 编辑时根据id获取配置
     */
    getConifgByRuleId(id) {
      this.getConfigLoading = true
      getDataReportingInfoByPage({ ruleName: id, pageIndex: 1, pageSize: 1 })
        .then((data) => {
          const [config] = data.list || []
          if (config) {
            this.configForm = DataReports.makeModifyConifgForm(config)
            this.getConfigLoading = false
          } else {
            this.$Message.warning('规则配置不存在，3秒后返回列表页')
            this.getConfigLoading = false
            setTimeout(() => {
              this.gotoListPage()
            }, 3000)
          }
        })
        .catch(() => {
          this.$Message.error('获取规则配置出错')
          this.getConfigLoading = false
        })
    }
  },
  created() {
    const { ruleId } = this.$route.query
    if (ruleId) {
      this.getConifgByRuleId(ruleId)
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin block {
  height: 240px;
  background: #f6f6f6;
  border-radius: 4px;
}
#data-report-config-form {
  overflow: auto;
}

.config-form {
  max-width: 1000px;
  margin: 0 auto;
  padding-top: 40px;
  .selector {
    display: flex;

    .lists {
      @include block;
      flex: 1;
      padding: 10px 0;
      .search-box {
        padding: 0 10px;
      }
      .checkbox-wrapper {
        height: 185px;
        overflow: auto;
        margin-top: 4px;
        padding-left: 10px;
        .checkbox-item {
          line-height: 12px;
          ::v-deep .el-checkbox {
            line-height: 12px;
          }
        }
      }
    }
  }
}
</style>
